import { Alert, Loading } from '@orobix/orobix-fe-components'
import i18next from 'i18next'

import { ErrorBanner } from './ErrorBanner'
import { FailedBanner } from './FailedBanner'
import { useStyles } from './IngestionStatusBanner.styles'
import { NeverBanner } from './NeverBanner'
import { resolveBannerVariant } from './resolveBannerVariant'
import { SyncedBanner } from './SyncedBanner'
import { useDataSyncStatus } from './useDataSyncStatus'

export const IngestionStatusBanner = () => {
  const classes = useStyles()
  const { data, isLoading, isError, refetch } = useDataSyncStatus()

  if (isLoading) {
    return (
      <Alert type="info" withBorder>
        <span className={classes.icon}>
          <Loading />
        </span>
        {`${i18next.t('Loading')}`}
      </Alert>
    )
  }

  if (isError || !data) {
    return <ErrorBanner onTryAgain={refetch} />
  }

  // 'ok' and 'stale' are the same banner: the variant only decides the colour
  // and whether the ageing warning is appended.
  switch (resolveBannerVariant(data)) {
    case 'failed':
      return <FailedBanner sync={data} />
    case 'never':
      return <NeverBanner sync={data} />
    case 'stale':
      return <SyncedBanner sync={data} stale />
    default:
      return <SyncedBanner sync={data} stale={false} />
  }
}
